export interface LocationData {
  ip: string;
  city: string;
  region: string;
  country: string;
  coordinates: {
    latitude: number;
    longitude: number;
  };
  timezone: string;
  metadata?: Array<{ id: number; data: string }>;
}

export interface WeatherData {
  temperature: number;
  condition: WeatherCondition;
  description: string;
  humidity: number;
  windSpeed: number;
  location: {
    city: string;
    country: string;
    coordinates: {
      lat: number;
      lon: number;
    };
  };
  timestamp: Date;
}

export type WeatherCondition = 
  | 'clear-day' 
  | 'clear-night' 
  | 'cloudy' 
  | 'partly-cloudy'
  | 'rain' 
  | 'snow' 
  | 'fog'
  | 'default';

export interface CacheEntry<T> {
  data: T;
  timestamp: Date;
  expiresAt: Date;
}

export interface WeatherCache {
  location: CacheEntry<LocationData>;
  weather: CacheEntry<WeatherData>;
}

export enum WeatherErrorType {
  LOCATION_DETECTION_FAILED = 'location_detection_failed',
  WEATHER_API_FAILED = 'weather_api_failed',
  NETWORK_ERROR = 'network_error',
  API_LIMIT_EXCEEDED = 'api_limit_exceeded'
}

export class WeatherError extends Error {
  constructor(
    public type: WeatherErrorType,
    message: string,
    public originalError?: Error
  ) {
    super(message);
    this.name = 'WeatherError';
  }
}